import { Suspense } from "react";
import { useRoutesMap } from "../providers/RoutesProvider";
import { resolveRoutes } from "../utils/routeHelpers";
import { Loading } from "../components/Loading/Loading";
import { RouteWithStaticFallback } from "./RouteWithStaticFallback";

export const ProjectRoutes = ({ content }) => {
  const routes = useRoutesMap();
  const resolvedRoutes = resolveRoutes(routes, { content });

  // Admin/manager route components are React.lazy — they need a Suspense
  // boundary above them to resolve their code chunk on first navigation.
  return resolvedRoutes ? (
    <Suspense fallback={<Loading />}>
      <RouteWithStaticFallback path="/" children={resolvedRoutes} />
    </Suspense>
  ) : null;
};
